import ImageGallery from '../../component/ImageGallery';
import Project from '../../component/Project';
import worldTradeCentreData from '../../data/DusitD2.json';
const DusitD2 = () => {
  const { pageData, containerData, content, images,imagesGallery,imagesGalleryleft, styles } = worldTradeCentreData;
  return (<>
      <Project pageData={pageData} containerData={containerData} content={content} images={images} styles={styles} />
      <ImageGallery imagesGallery={imagesGallery} imagesGalleryleft={imagesGalleryleft} />
      
 </>)
}

export default DusitD2
